import { forwardRef } from 'react';

import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconSmartphoneFilled } from '@zillow/constellation-icons';

import { PHOTO_UPLOAD_FROM_PHONE_TEXT } from '../../../constants/PhotoUploadConstants';

import { containerRecipe } from '../../UploadDropzone/styles';

import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  isDisabled?: boolean;
};

const PhoneUploadTile = forwardRef<HTMLButtonElement, Props>(({ isDisabled = false, ...buttonProps }, ref) => (
  <Box
    asChild
    css={containerRecipe.raw({
      isContainerSizeFixed: false,
      isSmallDropzone: true,
      isDisabled,
      isDragAccept: false,
      isDragReject: false,
    })}
  >
    <button {...buttonProps} ref={ref} type="button" data-testid="qr-photo-upload-button" disabled={isDisabled}>
      <Icon render={<IconSmartphoneFilled />} size="lg" />
      <Text css={{ marginTop: 'tight', whiteSpace: 'pre-line' }}>{PHOTO_UPLOAD_FROM_PHONE_TEXT}</Text>
    </button>
  </Box>
));

PhoneUploadTile.displayName = 'PhoneUploadTile';

export default PhoneUploadTile;
